/** Keep in sync with trove-extension/src/bg/extension-recaptcha-verifier.ts */
export const MFA_RECAPTCHA_REQUEST = 'MFA_RECAPTCHA_REQUEST';
export const MFA_RECAPTCHA_RESPONSE = 'MFA_RECAPTCHA_RESPONSE';
export const MFA_RECAPTCHA_RESET = 'MFA_RECAPTCHA_RESET';

export const MFA_RECAPTCHA_CONTAINER_ID = 'mfa-recaptcha-container';

/** Stub token when Auth emulator has app verification disabled (no getRecaptchaConfig). */
export const MFA_EMULATOR_RECAPTCHA_TOKEN = 'token';
